import React from 'react';
import Typography from '@mui/material/Typography';

interface InfoRowProps {
  title: string;
  value?: React.ReactNode;
  icon?: React.ReactNode;
  iconImgSrc?: string;
  containerStyle?: React.CSSProperties;
}

const InfoRow = ({
  title,
  value,
  icon,
  iconImgSrc,
  containerStyle
}: InfoRowProps) => {
  return (
    <div style={{ border: '1px solid #E5E7EB', borderRadius: '8px', padding: '6px 8px', marginBottom: '10px', ...(containerStyle || {}) }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <div style={{ width: 32, height: 32, borderRadius: '50%', backgroundColor: '#F2F4F7', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          {iconImgSrc ? (
            <img src={iconImgSrc} alt="" style={{ width: 20, height: 20 }} />
          ) : (
            icon || <div style={{ width: 20, height: 20 }} />
          )}
        </div>
        <div style={{ flex: 1 }}>
          <Typography variant="body2" color="textSecondary" style={{ fontSize: 13, marginBottom: 2 }}>{title}</Typography>
          {value !== undefined && (
            <Typography variant="body1" style={{ fontSize: 14, fontWeight: 400 }}>
              {value}
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
};

export default InfoRow;


